import { Component } from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import EmbedRecentArticles from "../Pages/Embedded/RecentArticles"
import Analytics from "../Utilities/Analytics"

class Embeds extends Component {
    render() {
        return (
            <BrowserRouter>
                <Analytics />
                <Routes>
                    <Route exact path="/embed/recent-articles" element={<EmbedRecentArticles />} />
                </Routes>
            </BrowserRouter>
        )
    }
}

export default Embeds